import { render, staticRenderFns } from "./OpenSourceApiSection.vue?vue&type=template&id=2820104c&scoped=true"
import script from "./OpenSourceApiSection.vue?vue&type=script&lang=ts"
export * from "./OpenSourceApiSection.vue?vue&type=script&lang=ts"
import style0 from "./OpenSourceApiSection.vue?vue&type=style&index=0&id=2820104c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2820104c",
  null
  
)

export default component.exports